<template>
    <div class="school-box">
        <ChildBanner :childbannerData='childbannerData' ref='childBaner' class="white"></ChildBanner>
        <DoBetter :childModle='childModleData' class="black"></DoBetter>
        <College class="black"></College>
    </div>
</template>
<script>
    import ChildBanner from '@/components/base/childbanner'//引入子页面的banner
    import DoBetter from '@/components/main/contact/dobetter'//引入页面说明    
    import College from '@/components/main/school/college'//引入博客  
    export default {
        name: 'School',
        data() {
            return {
                childbannerData: {
                    childbanner: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/%E7%BB%84%20750.jpg',
                    caption: 'marketing college',
                    title: '蓝鲸营销学院'
                },
                childModleData: {
                    caption: 'Latest Events',
                    center: '很荣幸, 因为我们有您的关注。同时, 恭喜您, 您可能和一家真正专业的公司有合作的机会。因此, 了解以下的合作原则, 对于彼此的共事质量很重要, 了解我们的行事方法和思想, 能在今后的合作中规避矛盾, 加快效率。 彼此协助, 彼此信任, 方能将美好的蓝图兑现。',
                    title: '品牌策划的规律，这些您掌握了吗？',
                    topath: {
                        name: '参与报名 >',
                        url: '/about'
                    }
                }
            }
        },
        components: {
            ChildBanner,
            DoBetter,
            College
        },
        mounted() {
            this.getList()
        },
        methods: {
            childMethods() {
                this.$refs.childBaner.changeShow()
            },
            getList() {//获取文章列表
                this.$axios.get(this.$API.lookArticl, {
                    params: {
                        'article_type_id': 2,
                        'per_page': 1,
                        'page': 1
                    }
                }
                )
                    .then(res => {
                        this.changeContent(res.data.data)
                    })
                    .catch(err => {
                        this.$message.error('文章列表获取失败，刷新页面重试')
                    })
            },
            // 过滤获取的富文本标签
            changeContent(res) {
                let news = res
                let _this = this;
                let str = news[0].content;
                str = str.replace(/(\n)/g, "");
                str = str.replace(/(\t)/g, "");
                str = str.replace(/(\r)/g, "");
                str = str.replace(/<\/?[^>]*>/g, "");
                news[0].content = str;
                _this.childModleData.center = news[0].content
                _this.childModleData.title = news[0].title
                // setTimeout(() => {
                //     _this.loading = false
                // }, 1000)
            },
        }
    }
</script>
<style scoped>
    .school-box>>>.DoBetter {
        padding: 301px 0 200px 0;
    }

    .DoBetter>>>.center-caption {
        top: 0;
        left: 14%;
        transform: translateY(50%);
        font-size: 7.2vw;
        font-weight: bold;
        text-transform: none;
        color: rgba(34, 34, 34, 1);
    }

    .DoBetter>>>.center-caption::before {
        content: '近期活动';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 32px;
        font-weight: 500;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);

    }

    .DoBetter>>>.center-box::after {
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20190910103922(1)(2).jpg') no-repeat center center;
    }

    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.center-box::before {
        content: 'college';
        transform: rotate(90deg) translate(26%, -142px);
    }

    .DoBetter>>>.center-box {
        padding-top: 176px;
        padding-bottom: 10%;
    }

    .DoBetter>>>.title-caption {
        max-width: 47.57%;
    }

    .DoBetter>>>.text-center {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
    }
    .DoBetter>>>.pathtoUrl{
        display: none;
    }
    .DoBetter>>>.pathtoForm{
        display: block;
    }

    @media(max-width: 1028px) {
        .DoBetter>>>.center-caption {
            line-height: 290px;
        }
    }

    @media(max-width: 995px) {
        .school-box>>>.DoBetter {
            padding: 0;
        }

        .DoBetter>>>.center-caption {
            display: none;
        }

        .DoBetter>>>.center-box {
            padding: 5%;
            justify-content: center;
            align-items: center;
            min-height: auto;
        }

        .DoBetter>>>.title-caption {
            padding-top: 5%;
            margin-bottom: 0;
            max-width: 100%;
        }

        .DoBetter>>>.text-center {
            padding: 0;
        }
    }

    /* @media(max-width: 1023px) {
        .school-box>>>.DoBetter {
        padding: 301px 0 500px 0;
        padding-bottom: 600px;
    }
        .DoBetter>>>.center-box {
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20190910103922(1)(2).jpg') no-repeat center;
            background-size: cover;
        }
        .DoBetter>>>.title-caption{
            position: absolute;
            left: 5%;
            bottom: 15%;
            color: #ffffff;
            font-size: 75px;
            line-height: 150%;
        }

        .DoBetter>>>.center-box::after {
            display: none;
        }

        .DoBetter>>>.center-caption {
            top: 0;
            left: 168px;
            transform: translate(88%,-8%);
            font-size: 140px;
            font-weight: bold;
            text-transform: none;
            color: rgba(34, 34, 34, 1);
        }

        .DoBetter>>>.center-caption::before {
            font-size: 50px;
            line-height: 100%;

        }
    }
    @media(max-width: 375px){
        .school-box>>>.DoBetter {
        padding-bottom: 800px;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/school.vue